import '@/theme/styles.css'
import '@/localization'
import 'virtual:svg-icons-register'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from '@/App'
import { UiToaster } from '@/ui/UiToaster'

const root = createRoot(document.getElementById('root') as Element)

root.render(
  <StrictMode>
    <App />
    <UiToaster />
  </StrictMode>,
)
